export const errorConstants = {

    GET_ALL_SUCCESS: "ERRORS_GET_ALL_SUCCESS",
    FAILURE: "ERRORS_FAILURE",
    REQUEST: "ERRORS_REQUEST",
};
